<!-- Modal -->
<div class="block mx-auto modal-box">
   <div class="modal1 promotion-modal" id="modal-login">
      <button title="Close (Esc)" type="button" class="mfp-close p-t-10" (click)="onCloseDialog()">×</button>
      <div class="row">
         <div class="col-lg-12">
            <div class="p-t-20 p-r-20 p-l-20">
               <div class="d-flex">
                  <div class="text-left mb-0 d-flex align-items-center">
                     <img *ngIf="this.data.reupload === true" class="bill mr-2" [innerHTML]="svg.receiptIcon | safeHtml" style="float: left;">
                     <h3 class="m-0" style="position: relative;">{{ this.verificationTitle }}</h3>
                  </div>
               </div>
               <hr>
               <div class="col-12 p-l-0 p-r-0">
                  <ng-container *ngIf="(this.data.reupload === true && this.data.bankVerificationStatus != 4) else Other">
                     <div class="ewallet-detail mb-4">
                        <p class="text-center m-b-0">
                           {{'Reason' | translate}}: {{ this.data.reason }}
                        </p>
                     </div>
                  </ng-container>
                  <ng-template #Other>
                     <div class="promotion-details text-justify text-color mb-4" [innerHTML]="this.verificationContent"></div>
                  </ng-template>
               </div>
               <form class="row" [formGroup]="form" id="ewallet-verification-modal-form" name="ewallet-verification-modal-form">
                  <ng-container formGroupName="verification_details">
                     <ng-container *ngFor="let value of verificationField; let i = index" [formGroupName]="value.verification_setting_field_id">
                        <!-- Upload Document -->
                        <div class="col-12" *ngIf="value.type_name == 'Upload File'">
                           <label>{{ value.label }}</label>
                           <div class="row">
                              <div class="col d-flex flex-row flex-wrap">
                                 <div class="receipt-box d-flex justify-content-center align-items-center"
                                    *ngFor="let image of uploaded_images[value.verification_setting_field_id]; let imgIndex = index">
                                    <img *ngIf="!image.isPdf" [src]="image.path" alt="{{ 'Image Preview' | translate }}" />
                                    <iframe *ngIf="image.isPdf" width="100%" height="100%" [src]="image.path" frameborder="0"
                                       style="border:0" allowfullscreen></iframe>
                                    <div class="trash-img-div d-flex justify-content-end align-items-start">
                                       <span [innerHTML]="svg.trashIcon | safeHtml" (click)="onRemoveFileMulti(imgIndex, value.verification_setting_field_id)"></span>
                                    </div>
                                 </div>
                                 <div *ngIf="uploaded_images[value.verification_setting_field_id]?.length < max_receipts" class="receipt-box d-flex justify-content-center align-items-center">
                                    <input type="file" accept="image/*, application/pdf" (change)="onUploadFileMulti($event, value.verification_setting_field_id, i)" #myFileInput hidden />
                                    <span *ngIf="!uploadInProgress[i]" class="upload-action-btn" [innerHTML]="svg.uploadIcon | safeHtml" (click)="myFileInput.click()"></span>
                                    <span *ngIf="uploadInProgress[i]" class="spinner-border"></span>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12 p-0">
                              <p>{{ 'Max file size is 10MB'| translate}}</p>
                           </div>
                        </div>
                        <!-- Text Field -->
                        <div class="col-12" *ngIf="value.type_name == 'Textbox'">
                           <label>{{ value.label }}</label>
                           <input type="text" class="form-control form-control-sm form-input-style m-b-10" formControlName="verification_text" />
                        </div>
                     </ng-container>
                  </ng-container>
                  <div class="col-12">
                     <div class="col-12 p-r-0 p-l-0 p-t-20 text-center">
                        <button type="submit" class="button-blue w-100" [ngClass]="{'disabled': !form.valid}"
                           [disabled]="!form.valid" (click)="onSave()">{{ 'Submit' | translate }}</button>
                     </div>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!--End modal-->
<app-swal-alert [message]="messages$ | async" [success]="isSuccess" [ewalletVerification]="true"></app-swal-alert>